import React from "react";

export default function CompanyForm() {
  return <div>CompanyForm</div>;
}
